import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import {
    OreButton,
    OreStack,
} from '@edenredespana/oreneta'
import { HelpCenterTranslations } from '@/HelpCenter/ui/helpCenterTranslations'
import { navigationRoutes } from '@/Shared/ui/routers'
import { PlusCricleIcon } from '@/Shared/ui/assets/PlusCircle'
import { useHelpCenter } from '@/HelpCenter/ui/context'

export const MyTicketsFooter = (): JSX.Element => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { ticketHistory } = useHelpCenter()

    return (
        <div
            style={{
                position: 'sticky',
                bottom: 0,
                backgroundColor: '#F8FAFC',
                zIndex: 10,
            }}>
            <OreStack
                space="medium"
                placeContent="stretch"
                style={{ 
                    padding: '0 3rem',
                    maxWidth: '1200px',
                    margin: '0 auto',
                    }}>
                <OreStack
                    direction="row"
                    placeContent="center"
                    style={{
                        padding: '0 3rem 1rem 3rem',
                    }}>
                    {ticketHistory.length > 0 && (
                        <OreButton
                            category="primary"
                            onClick={() => navigate(navigationRoutes.newTicket)}
                            icon={<PlusCricleIcon />}>
                            {t(HelpCenterTranslations.myTickets.newTicket)}
                        </OreButton>
                    )}
                </OreStack>
            </OreStack>
        </div>
    )
}
